import { render, staticRenderFns } from "./TaskRecord.vue?vue&type=template&id=44f81bda&scoped=true"
import script from "./TaskRecord.vue?vue&type=script&lang=js"
export * from "./TaskRecord.vue?vue&type=script&lang=js"
import style0 from "./TaskRecord.vue?vue&type=style&index=0&id=44f81bda&scoped=true&lang=css"
import style1 from "./TaskRecord.vue?vue&type=style&index=1&id=44f81bda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f81bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f81bda')) {
      api.createRecord('44f81bda', component.options)
    } else {
      api.reload('44f81bda', component.options)
    }
    module.hot.accept("./TaskRecord.vue?vue&type=template&id=44f81bda&scoped=true", function () {
      api.rerender('44f81bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/task/TaskRecord.vue"
export default component.exports